import FormControl from "@mui/material/FormControl";
import AutocompleteMui from "@mui/material/Autocomplete";
import { TextField, Typography } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import { Controller } from "react-hook-form";
import "./Autocomplete.css";

const Autocomplete = (props) => {
    const {
        name, label, subtitle, control, error,
        placeholder, disabled, options, getOptionLabel,
        helpertextrequired = true,
        required,
    } = props;

    return (
        <FormControl error={!!error} className={`autocomplete-field${disabled ? " field-disabled" : ""}`}>
            {label && (
                <label htmlFor={name}>
                    {label}
                    {required ? <span className="required-field">*</span> : null}
                </label>
            )}
            {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
            <Controller
                render={({
                    field: {
                        value, ref, onChange, ...field
                    },
                }) => (
                    <AutocompleteMui
                        id={name}
                        variant="outlined"
                        disabled={disabled}
                        placeholder={placeholder}
                        options={options}
                        renderInput={(params) => <TextField inputRef={ref} {...params} error={!!error} helperText={null} />}
                        getOptionLabel={getOptionLabel}
                        value={value}
                        onChange={(e, newValue) => onChange(newValue)}
                        {...field}
                    />
                )}
                name={name}
                control={control}
            />
            {helpertextrequired ? error ? <FormHelperText>{error}</FormHelperText> : null : null}
        </FormControl>
    );
};

export default Autocomplete;
